<template>
  <div class="extension_time__form">
    <h1>ยื่นขอขยายเวลา</h1>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout class="d-flex align-center mt-6">
        <v-flex shrink mr-3>
          <v-img
            :src="
              require('../../../../assets/images/extension-time/calendar-add.png')
            "
            width="20"
            height="20"
          ></v-img>
        </v-flex>
        <v-flex shrink>
          <div class="font-20 font-w-600">รายละเอียดการขอขยายเวลา</div>
        </v-flex>
      </v-layout>

      <div class="custom_card mt-4">
        <v-layout wrap>
          <v-flex lg2 md3 class="font-14 font-w-600 mb-2">แผนงาน</v-flex>
          <v-flex lg10 md9>
            <div class="font-14 mb-3">{{ form.plan_name }}</div>
          </v-flex>
          <v-flex lg2 md3 class="font-14 font-w-600 mb-2"
            >ชื่อโครงการ(ไทย)</v-flex
          >
          <v-flex lg10 md9>
            <div class="font-14 mb-3">{{ form.project_name }}</div>
          </v-flex>
        </v-layout>
      </div>

      <div class="custom_card mt-4">
        <div class="font-20 font-w-700">แผนการดำเนินงานวิจัย</div>

        <v-layout class="mt-5">
          <v-flex xs4>
            <div class="font-14 font-w-600 mb-2">
              ครั้งที่ <span style="color: #f15a29">*</span>
            </div>
            <v-text-field
              v-model="form.round"
              outlined
              height="36"
              type="number"
              color="#D3D3D3"
              style="border-radius: 30px"
              disabled
              background-color="#EFEFEF"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs4>
            <div class="font-14 font-w-600 mb-2">
              ระยะเวลาที่ขยายเวลา (เดือน) <span style="color: #f15a29">*</span>
            </div>
            <v-text-field
              v-model="form.duration"
              outlined
              height="36"
              type="number"
              color="#D3D3D3"
              style="border-radius: 30px"
              disabled
              background-color="#EFEFEF"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <v-col cols="4">
            <div class="font-14 font-w-600 mb-2">
              ขยายเวลาตั้งเเต่วันที่ <span style="color: #f15a29">*</span>
            </div>
            <v-text-field
              v-model="form.start_date"
              append-icon="mdi-calendar"
              disabled
              height="36"
              outlined
              style="border-radius: 30px"
              background-color="#EFEFEF"
              class="mt-0"
            ></v-text-field>
            <!-- <v-menu
              v-model="menu_start_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.start_date"
                  placeholder="โปรดระบุ"
                  append-icon="mdi-calendar"
                  readonly
                  height="36"
                  outlined
                  style="border-radius: 30px"
                  class="mt-0"
                  :rules="[(v) => !!v || 'กรุณาระบุวันที่เริ่มต้น']"
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.start_date"
                @input="menu_start_date = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
          <v-col cols="4">
            <div class="font-14 font-w-600 mb-2">
              ถึงวันที่ <span style="color: #f15a29">*</span>
            </div>
            <v-text-field
              v-model="form.end_date"
              append-icon="mdi-calendar"
              disabled
              height="36"
              outlined
              style="border-radius: 30px"
              background-color="#EFEFEF"
              class="mt-0"
            ></v-text-field>
            <!-- <v-menu
              v-model="menu_end_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.end_date"
                  placeholder="โปรดระบุ"
                  append-icon="mdi-calendar"
                  readonly
                  height="36"
                  outlined
                  style="border-radius: 30px"
                  class="mt-0"
                  :rules="[(v) => !!v || 'กรุณาระบุวันที่สิ้นสุด']"
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.end_date"
                @input="menu_end_date = false"
              ></v-date-picker>
            </v-menu> -->
          </v-col>
        </v-row>

        <v-layout class="mt-6">
          <v-flex xs12>
            <div class="font-14 font-w-600 mb-2">
              เหตุผล <span style="color: #f15a29">*</span>
            </div>
            <v-textarea
              v-model="form.reason"
              outlined
              dense
              rows="5"
              color="#D3D3D3"
              style="border-radius: 30px"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุเหตุผล']"
              required
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-space-between>
          <v-flex shrink class="font-14 font-w-700 mb-2">เอกสารเเนบ</v-flex>
          <v-flex shrink>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#F15A29"
              @click="addFile"
            >
              <v-icon class="font-12 font-w-700" left>mdi-plus</v-icon>
              <span class="font-12 font-w-700">เพิ่มไฟล์</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <div class="font-14" style="color: #f15a29">
          *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 50 MB/ไฟล์)
        </div>
        <v-layout class="mt-3" v-for="(file, f) in form.files" :key="f">
          <v-flex xs7>
            <v-file-input
              :id="'file' + f"
              color="#F15A29"
              :clearable="false"
              style="border-radius: 30px"
              outlined
              height="36"
              placeholder=""
              prepend-icon=""
              hide-input
              accept="application/pdf,.doc,.docx"
              @change="handleUploadFile($event, f)"
            ></v-file-input>
            <v-text-field
              v-model="file.file_name"
              outlined
              height="36"
              color="#F15A29"
              style="border-radius: 30px"
              readonly
              :rules="[(v) => !!v || 'กรุณาแนบเอกสาร']"
              clearable
              @click:clear="clearFile(f)"
            ></v-text-field>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#464647"
              @click="uploadFile(f)"
            >
              <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
              <span class="font-12 font-w-700">อัพโหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              height="35"
              width="35"
              fab
              dark
              color="#FD0C0C"
              @click="removeFile(f)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-layout class="mt-5">
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#D9D9D9"
            @click="$router.go(-1)"
          >
            <span class="font-14 font-w-700" style="color: #464647">
              ยกเลิก
            </span>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex v-if="form_type === 'C'" shrink mr-4 >
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#FBB040"
            @click="onSubmit('Draft')"
          >
            <span class="font-14 font-w-700">บันทึกฉบับร่าง</span>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            style="
              background: linear-gradient(
                21.01deg,
                #f15a29 6.18%,
                #fbb040 84.83%
              );
            "
            class="btn-save"
            @click="onSubmit('Submitted')"
          >
            <span class="font-14 font-w-700">บันทึก</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
import SERVICES from "../../../../services";
import axios from "axios";
import { apiDomain } from "../../../../store/constants";

export default {
  components: { DatePicker },
  data() {
    return {
      valid: true,
      menu_start_date: false,
      menu_end_date: false,
      form: {
        plan_name: "",
        project_name: "",
        round: "",
        duration: "6",
        start_date: null,
        end_date: null,
        reason: null,
        status: null,
        files: [],
        form_c_id: null,
        form_b_id: null,
        plan_master_id: null,
        fiscal_year: null,
        region: null,
      },
      form_type: "C",
      rulesFile: [
        (value) =>
          !value ||
          value.size < 50000000 ||
          "File size should be less than 50 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    };
  },
  created() {
    // check params id ถ้าไม่มีแสดงว่ากดปุมาสร้าง ถ้ามีแสดงว่ากดปุ่มแก้ไข
    let form_id = this.$route.params.form_c_id;
    if(!form_id) {
      this.form_type = "F";
      form_id = this.$route.params.form_b_id;
    }
    if (!this.$route.params.id) {
      this.createForm(form_id);
    } else {
      this.editForm(this.$route.params.id);
    }
  },
  methods: {
    async createForm(form_id) {
      this.$store.commit("General/setLoading");
      const res = await SERVICES.USPExtend.create(form_id, this.form_type);
      this.$store.commit("General/setLoading", false);
      if (res.status == 200) {
        this.form.plan_master_id = res.data.data.plan_master_id;
        this.form.plan_name = res.data.data.plan_name;
        this.form.project_name = res.data.data.project_name_th;
        this.form.fiscal_year = res.data.data.fiscal_year;
        this.form.region = res.data.data.region;
        this.form.round = res.data.data.round;
        this.form.start_date = res.data.data.start_date;
        this.form.end_date = res.data.data.end_date;
      } else {
        this.$store.commit("General/setModal", {
          title: "Something went wrong!",
          showCancel: false,
          theme: "error",
          buttonText: "OK",
          text: res.data.message,
          action: () => {
            this.$router.go(-1);
          },
        });
      }
    },
    async editForm(id) {
      this.$store.commit("General/setLoading");
      const res = await SERVICES.USPExtend.edit(id);
      this.$store.commit("General/setLoading", false);
      if (res.status == 200) {
        this.form.status = res.data.data.status;
        this.form.form_c_id = res.data.data.form_c_id;
        this.form.form_b_id = res.data.data.form_b_id;
        this.form.plan_master_id = res.data.data.plan_master_id;
        this.form.plan_name = res.data.data.plan_name;
        this.form.project_name = res.data.data.project_name;
        this.form.fiscal_year = res.data.data.fiscal_year;
        this.form.region = res.data.data.region;
        this.form.round = res.data.data.round;
        this.form.start_date = res.data.data.start_date;
        this.form.end_date = res.data.data.end_date;
        this.form.reason = res.data.data.reason;
        // map files
        const files = res.data.data.files;
        this.form.files = files;
      } else {
        this.$store.commit("General/setModal", {
          title: "Something went wrong!",
          showCancel: false,
          theme: "error",
          buttonText: "OK",
          text: res.data.message,
          action: () => {
            this.$router.go(-1);
          },
        });
      }
    },
    addFile() {
      this.form.files.push({
        parent_table: null,
        parent_id: null,
        file_name: null,
        file_path: null,
        file_extension: null,
        full_path: null,
      });
    },
    removeFile(id) {
      this.form.files.splice(id, 1);
    },

    clearFile(id) {
      this.form.files[id] = {
        parent_table: null,
        parent_id: null,
        file_name: null,
        file_path: null,
        file_extension: null,
        full_path: null,
      };
    },

    async uploadFile(id) {
      document.querySelector("#file" + id).click();
    },

    async handleUploadFile(file, index) {



      if(file.size > 50000000){
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        //remove file in to last index of attachment
        this.form.files.pop()
        return
      }
      let file_id = this.form.files[index].id;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("folder", "/uploads/pending-form/");
      const res = await axios.post(`${apiDomain}api/upload-file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status == 200) {
        this.form.files[index] = res.data.attachments;
        if (file_id) {
          this.form.files[index].id = file_id;
        }
        this.$forceUpdate();
      } else {
        this.$store.commit("General/setModal", {
          title: "Something went wrong!",
          showCancel: false,
          theme: "error",
          buttonText: "OK",
          text: res.data.message,
        });
      }
    },

    checkValType(val) {
      return typeof val;
    },

    onSubmit(type) {
      if (this.$refs.form.validate()) {
        this.form.status = type;
        this.onSave();
      }
    },

    async onSave() {
      this.$store.commit("General/setLoading");
      let res = null;

      // check ว่าเป็น  create หรือ update
      if (!this.$route.params.id) {
        this.form.form_c_id = this.$route.params.form_c_id;
        this.form.form_b_id = this.$route.params.form_b_id;
        res = await SERVICES.USPExtend.store(this.form);
      } else {
        res = await SERVICES.USPExtend.update({
          id: this.$route.params.id,
          data: this.form,
        });
      }

      this.$store.commit("General/setLoading", false);

      if (res.status == 200) {
        this.$router.push("/rsp/extend-time");
      } else {
        this.$store.commit("General/setModal", {
          title: "Something went wrong!",
          showCancel: false,
          theme: "error",
          buttonText: "OK",
          text: res.data.message,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.extension_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 4px !important;
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: inherit !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  .v-input__icon--clear {
    background: #d9d9d9;
    color: #fff !important;
  }

  .btn-save {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 0px 10px;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
